var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill',{ref:"editor",attrs:{"output":"html","config":Object.assign({}, _vm.config,
    {placeholder: _vm.placeholder}),"content":_vm.value},on:{"input":function($event){return _vm.onEditorChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }